const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/builds/$id/install-options.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/builds/$id/install-options")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      id
    } = params;
    const {
      queryClient
    } = context;
    await queryClient.prefetchQuery({
      queryKey: ["builds", "install-options", {
        id
      }],
      queryFn: async () => httpClient.get<BuildInstallOptions>(`/builds/${id}/install-options`).catch(() => null)
    });
    return {
      id,
      dehydratedState: dehydrate(queryClient)
    };
  }
});